// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import "./student.css"
// const Studentadd = () => {
//   const [formData, setFormData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [editData, setEditData] = useState({});
//   const [district, setDistrict] = useState('');
//   const [taluka, setTaluka] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');
//   const [successMessage, setSuccessMessage] = useState('');
//   const navi = useNavigate();
//   const [searchTerm, setSearchTerm] = useState('');

//   const [appliedData,setappliedData]=useState([])



//   const handleAdd = () => {
//     navi('/studentform');
//   };

//   const fetchData = async () => {
//     try {
//       const adminId = localStorage.getItem('UserId'); // or however you store it
  
//       const response = await axios.get(
//         `${process.env.REACT_APP_API}/getstudentinfo/studentform?adminId=${adminId}`
//       );
  
//       setFormData(response.data);
//     } catch (err) {
//       setError(err.response?.data?.message || 'Error fetching data');
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   const handleView = async (id) => {
//     try {
//       const viewdata = await axios.get(`${process.env.REACT_APP_API}/viewstudent/showstudent/${id}`);

//       setSelectedItem(viewdata.data);
//       setIsEditing(false);
//       setShowModal(true);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handleEdit = (id) => {
  
//     const itemToEdit = formData.find(item => item.id === id);
//     setEditData(itemToEdit);
//     setDistrict(itemToEdit.district); // Set district for editing
//     setTaluka(itemToEdit.taluka); // Set taluka for editing
//     setIsEditing(true);
//     setShowModal(true);
//   };

// const isAppPlayed = async () => {
//   try {
//     const response = await axios.get(`${process.env.REACT_APP_API}/auth/isappalayed`);

//     // const userIds = response.data.map(item => item.UserId );
//     // setappliedData(userIds)
//     const userIds = response.data.map(item => ({
//   UserId: item.UserId,
//   standard: item.standard,
//   medium: item.medium
// }));
// setappliedData(userIds);

//   } catch (error) {
//     console.log(error);
//   }
// };


//   const handleEditSubmit = async (e) => {
//     e.preventDefault();

//     // Form validation
//     if (!editData.studentName || !editData.phoneNumber || !district || !taluka) {
//       setErrorMessage('Please fill in all fields.');
//       return;
//     }

//     setLoading(true); // Start loading state
//     setErrorMessage(''); // Clear error message
//     setSuccessMessage(''); // Clear success message

//     // Update the editData object with the selected district and taluka
//     const updatedData = { ...editData, district, taluka };

//     try {
//       await axios.put(`${process.env.REACT_APP_API}/updatestudent/changestudentform/${editData.id}`, updatedData);
//       setSuccessMessage('Student updated successfully');
//       setShowModal(false);
//       fetchData(); // Refresh the data after successful edit
//     } catch (err) {
//       setErrorMessage('Error updating student');
//       console.error('Error updating student:', err);
//     } finally {
//       setLoading(false); // Reset loading state
//     }
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setErrorMessage('');
//     setSuccessMessage('');
//   };

//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setEditData(prevState => ({
//       ...prevState,
//       [id]: value
//     }));
//   };

//   const handleDistrictChange = (e) => {
//     const selectedDistrict = e.target.value;
//     setDistrict(selectedDistrict);
//     setTaluka(''); // Reset Taluka when district changes
//   };

//   const handleTalukaChange = (e) => {
//     setTaluka(e.target.value);
//   };

//   useEffect(() => {
//     fetchData();
//     isAppPlayed()

//   }, []);
// const filteredData = formData.filter((item) =>
//   Object.values(item).some((val) =>
//     String(val).toLowerCase().includes(searchTerm.toLowerCase())
//   )
// );

//   const districtToTalukas = {
//     chennai: ["Alandur", "Ambattur", "Aminjikarai", "Ayanavaram", "Egmore", "Guindy", "Madhavaram", "Madhuravoyal", "Mambalam", "Mylapore", "Perambur", "Purasavakkam", "Sholinganallur", "Thiruvottriyur", "Tondiarpet", "Velacherry"],
//     Coimbatore: ["Aanaimalai", "Annur", "Coimbatore(North)", "Coimbatore(South)", "Kinathukadavu", "Madukarai", "Mettupalayam", "Perur", "Pollachi", "Sulur", "Valparai"],
//     Cuddalore: ["Cuddalore", "Bhuvanagiri", "Chidambaram", "Kattumannarkoil", "Kurinjipadi", "Panruti", "Srimushnam", "Thittakudi", "Veppur", "Virudhachalam"],
//     Dharmapuri:['Dharmapuri'	,'Harur'	,	'Karimangalam' ,		'Nallampalli'	,	'Palacode'	,'Pappireddipatti'	,	'Pennagaram'],
//     Dindigul:['Atthur','Dindigul(East)','Dindigul (West)','Guziliyamparai',	'Kodaikanal',	'Natham',	'Nilakottai','Oddanchatram','Palani','Vedasandur'],
//     Erodei:['Erode','Anthiyur','Bhavani','Gobichettipalayam','Kodumudi', 'Modakurichi','Nambiyur','Perundurai','Sathiyamangalam','Thalavadi'],
//     Kancheepuram:['Kancheepuram', 'Kundrathur',  'Sriperumbudur', 'Uthiramerur' ,'Walajabad'],
//     Kanniyakumari:['Agasteeswaram',' Kalkulam','Killiyur','Thiruvatar','Thovalai','Vilavankodu'],
//     Karur:['Karur','Aravakurichi',' Kadavur',' Krishnarayapuram','Kulithalai','Manmangalam','Pugalur'],
//     Madurai:['Kallikudi',' Madurai (East)', 'Madurai (North)','Madurai (South)', 'Madurai (West)','  Melur', 'Peraiyur', 'Thirumangalam','Thiruparankundram','Usilampatti','Vadipatti'],
//     Nagapattinam:['Nagapattinam','Kilvelur','Thirukkuvalai','Vedaranyam'],
//     Namakkal:['Namakkal','Kholli Hills','Kumarapalayam','Mohanoor','Paramathi Velur',' Rasipuram','Senthamangalam','Tiruchengode'],
//      Nilgiris:['Udagamandalam','Coonoor','Gudalur','Kothagiri','Kundah','Pandalur'],
//      Perambalur:['Perambalur', 'Alathur','Kunnam','Veppanthattai'],
//      Pudukottai:['Pudukottai', 'Alangudi', 'Aranthangi', 'Avudiyarkoil','Gandarvakottai','Iluppur','Karambakudi',  'Kulathur', 'Manamelkudi','Ponnamaravathi','Thirumayam','Viralimalai'],
//      Ramanathapuram:['Ramanathapuram', 'Kadaladi', 'Kamuthi','Kezhakarai','Mudukulathur','Paramakudi','Rajasingamangalam', ' Rameswaram','Tiruvadanai'],
//      Salem:['Salem','Attur','Edapadi','Gangavalli','Kadaiyampatti','Mettur','Omalur','Pethanayakanpalayam', 'Salem South', ' Salem West', 'Sankari',' Vazhapadi', 'Yercaud'],
//      Sivagangai:['Sivagangai','Devakottai','Ilayankudi','Kalaiyarkovil','Karaikudi',' Manamadurai', 'Singampunari','Thirupuvanam','Tirupathur'],
//      Thanjavur:[ 'Thanjavur','Boothalur','Kumbakonam','Orathanadu','Papanasam','Pattukottai','Peravurani','Thiruvaiyaru','Thiruvidaimaruthur', ],
//      Theni:['Theni','Aandipatti','Bodinayakanur','Periyakulam','Uthamapalayam'],
//      Thiruvallur:['Thiruvallur','Avadi','Gummidipoondi','Pallipattu','Ponneri', 'Poonamallee', 'R.K. Pet','Tiruthani','Uthukottai'],
//      Thiruvannamalai:['Thiruvannamalai',' Arni','Chengam','Chetpet','Cheyyar','Jamunamarathur','Kalasapakkam','Kilpennathur','Polur',' Thandramet','Vandavasi','Vembakkam'],
//      Thiruvarur:['Thiruvarur','Kodavasal','Koothanallur','Mannargudi','Nannilam','Needamangalam','Thiruthuraipoondi','Valangaiman'],
//      Thoothukudi:['Thoothukudi','Eral','Ettayapuram','Kayathar','Kovilpatti','Ottapidaram','Sattankulam','Srivaikundam','Tiruchendur','Vilathikulam',],
//      Tiruchirappalli:['Lalgudi','Manachanallur', ' Manapparai',' Marungapuri','  Musiri',' Srirangam','  Thottiam', 'Thuraiyur',' Tiruchirapalli (West)','Tiruchirappalli (East)','Tiruverumbur'],
//      Tirunelveli:['Tirunelveli','Ambasamudram','Cheranmahadevi','Manur','Nanguneri','Palayamkottai','Radhapuram','Thisayanvilai'],
//      Vellore:['Vellore','Aanikattu','Gudiyatham','K V Kuppam','Katpadi','Pernambut', ],
//      Villupuram:['Villupuram','Gingee','Kandachipuram','Marakanam','Melmalaiyanur','Thiruvennainallur','Tindivanam','Vanur','Vikravandi'],
//      Virudhunagar:['Virudhunagar','Aruppukottai','Kariyapatti','Rajapalayam','Sathur','Sivakasi','Srivilliputhur','Tiruchuli','Vembakottai','Watrap' ],
//      Ariyalur:[' Ariyalur','Andimadam','Sendurai','Udaiyarpalayam' ],
//      Krishnagiri:['Krishnagiri','Anjetty','Bargur','Hosur','Pochampalli','Sulagiri','Thenkanikottai','Uthangarai',],
//      Tiruppur:['Avinashi','Dharapuram','Kangeyam','Madathukkulam','Oothukuli','Palladam','Tiruppur (North)','Tiruppur (South)','Udumalaipettai' ],
//      Chengalpattu:['Chengalpattu','Cheyyur','Maduranthakam','Pallavaram','Tambaram','Thirukalukundram','Tiruporur','Vandalur',],
//      Kallakurichi:['Kallakurichi','Chinnaselam','Kalvarayan Hills','Sankarapuram','Tirukoilur','Ulundurpet',],
//      Ranipet:['Arakkonam','Arcot','Kalavai','Nemili','Sholingur','Walajah',],
//      Tenkasi:[ 'Tenkasi','Alangulam','Kadayanallur','Sankarankovil','Shenkottai','Sivagiri','Thiruvengadam','Veerakeralampudur', ],
//      Tirupathur:['Tirupathur','Ambur','Natrampalli','Vaniyambadi',],
//      Mayiladuthurai:['Mayiladuthurai',' Kuthalam','Sirkali','Tharangambadi',], 
//   };

//   const handlePay = (studentName,UserId,referralId) => {
//     navi('/applyexam', { state: { studentName ,UserId  ,referralId } });
//     // console.log("Response received:", UserId);
//     // console.log("Response received:", referralid);
//   };
  
//   return (
//     <div>
//       <div style={{ marginBottom: '50px' }}>
//         <Link to="/" className="logo_image">
//           <img src="assets/headimg.jpg" alt="Cleenhearts HTML" style={{ width: '100%' }} />
//         </Link>
//       </div>

//       <div style={{ width: '100%', height: 'auto', display: 'flex', justifyContent: 'flex-end' }}>
//         <div
//           onClick={handleAdd}
//          style={{ width: '100px', height: '70px', backgroundColor: 'blueviolet', color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', margin: '10px' }}

//         >
//           ADD +
//         </div>

//       </div>

//    <div style={{ overflowX: 'auto' }}>
//   <input
//     type="text"
//     placeholder="Search..."
//     value={searchTerm}
//     onChange={(e) => setSearchTerm(e.target.value)}
//     style={{ marginBottom: '10px', padding: '5px', width: '300px' }}
//   />

//   {loading ? (
//     <p>Loading...</p>
//   ) : error ? (
//     <p style={{ color: 'red' }}>{error}</p>
//   ) : (
//     <table>
//       <thead>
//         <tr>
//           <th><h5>S.No</h5></th>
//           <th><h5>Student Name</h5></th>
//           <th><h5>Phone Number</h5></th>
//           <th><h5>UserID</h5></th>
//           <th><h5>Standard</h5></th>
//           <th><h5>Aadhar Number</h5></th>
//           <th><h5>Password</h5></th>
//           <th><h5>View</h5></th>
//           <th><h5>Edit</h5></th>
//           <th><h5>Action</h5></th>
//         </tr>
//       </thead>
//       <tbody>
//         {filteredData.length > 0 ? (
//           filteredData.map((item, index) => (
//             <tr key={item.id}>
//               <td>{index + 1}</td>
//               <td>{item.studentName}</td>
//               <td>{item.phoneNumber}</td>
//               <td>{item.UserId}</td>
//               {/* <td>{item.standard}</td> */}
        
// {(() => {
//   const matched = appliedData.find(data => data.UserId === item.UserId);
//   return matched ? <td>{matched.standard}</td> : <td>-</td>;
// })()}

//               <td>{item.aadharNumber}</td>
//               <td>{item.viewpass}</td>
//               <td>
//                 <button onClick={() => handleView(item.id)}>View</button>
//               </td>
//               <td>
//                 <button onClick={() => handleEdit(item.id)}>Edit</button>
//               </td>
//               <td>
//                 {appliedData.some(data => data.UserId === item.UserId) ? (
//                   <button type="button" className="button applied" disabled>
//                     {/* <span>A</span><span>P</span><span>P</span><span>L</span><span>I</span><span>E</span><span>D</span> */}
//                     APPLIED

//                   </button>
//                 ) : (
//                   <button
//                     type="button"
//                     className="button"
//                     onClick={() => handlePay(item.studentName, item.UserId, item.referralid)}
//                   >
//                     APPLY EXAM

//                     {/* <span>A</span><span>P</span><span>P</span><span>L</span><span>Y</span><span> </span><span>E</span><span>X</span><span>A</span><span>M</span> */}
//                   </button>
//                 )}
//               </td>
//             </tr>
//           ))
//         ) : (
//           <tr>
//             <td colSpan="8" style={{ textAlign: 'center' }}>No data available</td>
//           </tr>
//         )}
//       </tbody>
//     </table>
//   )}
// </div>


//       {/* Modal */}
//       {showModal && (
//         <div
//          style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', width: '100%' }}

//           onClick={handleCloseModal}
//         >
//           <div
//             style={{
//               backgroundColor: 'white',
//               padding: '20px',
//               borderRadius: '10px',
//               width: '400px',
//               minHeight: '200px',
//               overflowY: 'auto',
//               position: 'relative',
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             {isEditing ? (
//               <>
//                 <h3>Edit Details</h3>
//                 <form onSubmit={handleEditSubmit}>
//                   <input
//                     type="text"
//                     id="studentName"
//                     placeholder="Student Name"
//                     value={editData.studentName || ''}
//                     onChange={handleChange}
//                     style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
//                   />
//                   <input
//                     type="text"
//                     id="phoneNumber"
//                     placeholder="Phone Number"
//                     maxLength={10}
//                     value={editData.phoneNumber || ''}
//                     onChange={handleChange}
//                     style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
//                   />
//                   <select
//                     id="district"
//                     value={district}
//                     onChange={handleDistrictChange}
//                     style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
//                   >
//                     <option value="">Select a district</option>
//                     {Object.keys(districtToTalukas).map((districtKey) => (
//                       <option key={districtKey} value={districtKey}>
//                         {districtKey}
//                       </option>
//                     ))}
//                   </select>
//                   <select
//                     id="taluka"
//                     value={taluka}
//                     onChange={handleTalukaChange}
//                     style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
//                   >
//                     <option value="">Select Taluka</option>
//                     {districtToTalukas[district]?.map((talukaItem, index) => (
//                       <option key={index} value={talukaItem}>
//                         {talukaItem}
//                       </option>
//                     ))}
//                   </select>
//                   <button
//                     type="submit"
//                     style={{padding: '10px 20px', backgroundColor: '#007BFF',color: '#fff',  border: 'none',  cursor: 'pointer',  borderRadius: '10px',
//                     }}
//                   >
//                     Submit
//                   </button>
//                   {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
//                   {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
//                 </form>
//               </>
//             ) : (
//              <div>
//   <h3>View Details</h3>
//   <p><strong>Student Name:</strong> {selectedItem?.studentName}</p>
//   <p><strong>Phone Number:</strong> {selectedItem?.phoneNumber}</p>
//   <p><strong>District:</strong> {selectedItem?.District}</p>
//   <p><strong>Taluka:</strong> {selectedItem?.taluka}</p>
  
//   {/* Display medium if the user applied */}
//  {(() => {
//   const matched = appliedData.find(data => data.UserId === selectedItem?.UserId);
//   return matched ? (
//     <>
//       <p><strong>Medium:</strong> {matched.medium}</p>
//       <p><strong>Standard:</strong> {matched.standard}</p>
//     </>
//   ) : null;
// })()}

  
//   <button
//     onClick={handleCloseModal}
//     style={{
//       position: 'absolute',
//       top: '10px',
//       right: '10px',
//       backgroundColor: 'red',
//       color: 'white',
//       border: 'none',
//       padding: '5px 10px',
//       cursor: 'pointer',
//     }}
//   >
//     Close
//   </button>
// </div>

//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Studentadd;




import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import "./student.css"

const Studentadd = () => {
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({});
  const [district, setDistrict] = useState('');
  const [taluka, setTaluka] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navi = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [appliedData, setappliedData] = useState([]);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleAdd = () => {
    navi('/studentform');
  };

  const fetchData = async () => {
    try {
      const adminId = localStorage.getItem('UserId');
      const response = await axios.get(
        `${process.env.REACT_APP_API}/getstudentinfo/studentform?adminId=${adminId}`
      );
      setFormData(response.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Error fetching data');
    } finally {
      setLoading(false);
    }
  };

  const handleView = async (id) => {
    try {
      const viewdata = await axios.get(`${process.env.REACT_APP_API}/viewstudent/showstudent/${id}`);
      setSelectedItem(viewdata.data);
      setIsEditing(false);
      setShowModal(true);
    } catch (err) {
      console.error(err);
    }
  };

  const handleEdit = (id) => {
    const itemToEdit = formData.find(item => item.id === id);
    setEditData(itemToEdit);
    setDistrict(itemToEdit.district);
    setTaluka(itemToEdit.taluka);
    setIsEditing(true);
    setShowModal(true);
  };

  const isAppPlayed = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/auth/isappalayed`);
      const userIds = response.data.map(item => ({
        UserId: item.UserId,
        standard: item.standard,
        medium: item.medium
      }));
      setappliedData(userIds);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!editData.studentName || !editData.phoneNumber || !district || !taluka) {
      setErrorMessage('Please fill in all fields.');
      return;
    }
    setLoading(true);
    setErrorMessage('');
    setSuccessMessage('');
    const updatedData = { ...editData, district, taluka };
    try {
      await axios.put(`${process.env.REACT_APP_API}/updatestudent/changestudentform/${editData.id}`, updatedData);
      setSuccessMessage('Student updated successfully');
      setShowModal(false);
      fetchData();
    } catch (err) {
      setErrorMessage('Error updating student');
      console.error('Error updating student:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setErrorMessage('');
    setSuccessMessage('');
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setEditData(prevState => ({
      ...prevState,
      [id]: value
    }));
  };

  const handleDistrictChange = (e) => {
    const selectedDistrict = e.target.value;
    setDistrict(selectedDistrict);
    setTaluka('');
  };

  const handleTalukaChange = (e) => {
    setTaluka(e.target.value);
  };

  useEffect(() => {
    fetchData();
    isAppPlayed();
  }, []);

  const filteredData = formData.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const districtToTalukas = {
    chennai: ["Alandur", "Ambattur", "Aminjikarai", "Ayanavaram", "Egmore", "Guindy", "Madhavaram", "Madhuravoyal", "Mambalam", "Mylapore", "Perambur", "Purasavakkam", "Sholinganallur", "Thiruvottriyur", "Tondiarpet", "Velacherry"],
    Coimbatore: ["Aanaimalai", "Annur", "Coimbatore(North)", "Coimbatore(South)", "Kinathukadavu", "Madukarai", "Mettupalayam", "Perur", "Pollachi", "Sulur", "Valparai"],
    Cuddalore: ["Cuddalore", "Bhuvanagiri", "Chidambaram", "Kattumannarkoil", "Kurinjipadi", "Panruti", "Srimushnam", "Thittakudi", "Veppur", "Virudhachalam"],
    Dharmapuri:['Dharmapuri'	,'Harur'	,	'Karimangalam' ,		'Nallampalli'	,	'Palacode'	,'Pappireddipatti'	,	'Pennagaram'],
    Dindigul:['Atthur','Dindigul(East)','Dindigul (West)','Guziliyamparai',	'Kodaikanal',	'Natham',	'Nilakottai','Oddanchatram','Palani','Vedasandur'],
    Erodei:['Erode','Anthiyur','Bhavani','Gobichettipalayam','Kodumudi', 'Modakurichi','Nambiyur','Perundurai','Sathiyamangalam','Thalavadi'],
    Kancheepuram:['Kancheepuram', 'Kundrathur',  'Sriperumbudur', 'Uthiramerur' ,'Walajabad'],
    Kanniyakumari:['Agasteeswaram',' Kalkulam','Killiyur','Thiruvatar','Thovalai','Vilavankodu'],
    Karur:['Karur','Aravakurichi',' Kadavur',' Krishnarayapuram','Kulithalai','Manmangalam','Pugalur'],
    Madurai:['Kallikudi',' Madurai (East)', 'Madurai (North)','Madurai (South)', 'Madurai (West)','  Melur', 'Peraiyur', 'Thirumangalam','Thiruparankundram','Usilampatti','Vadipatti'],
    Nagapattinam:['Nagapattinam','Kilvelur','Thirukkuvalai','Vedaranyam'],
    Namakkal:['Namakkal','Kholli Hills','Kumarapalayam','Mohanoor','Paramathi Velur',' Rasipuram','Senthamangalam','Tiruchengode'],
     Nilgiris:['Udagamandalam','Coonoor','Gudalur','Kothagiri','Kundah','Pandalur'],
     Perambalur:['Perambalur', 'Alathur','Kunnam','Veppanthattai'],
     Pudukottai:['Pudukottai', 'Alangudi', 'Aranthangi', 'Avudiyarkoil','Gandarvakottai','Iluppur','Karambakudi',  'Kulathur', 'Manamelkudi','Ponnamaravathi','Thirumayam','Viralimalai'],
     Ramanathapuram:['Ramanathapuram', 'Kadaladi', 'Kamuthi','Kezhakarai','Mudukulathur','Paramakudi','Rajasingamangalam', ' Rameswaram','Tiruvadanai'],
     Salem:['Salem','Attur','Edapadi','Gangavalli','Kadaiyampatti','Mettur','Omalur','Pethanayakanpalayam', 'Salem South', ' Salem West', 'Sankari',' Vazhapadi', 'Yercaud'],
     Sivagangai:['Sivagangai','Devakottai','Ilayankudi','Kalaiyarkovil','Karaikudi',' Manamadurai', 'Singampunari','Thirupuvanam','Tirupathur'],
     Thanjavur:[ 'Thanjavur','Boothalur','Kumbakonam','Orathanadu','Papanasam','Pattukottai','Peravurani','Thiruvaiyaru','Thiruvidaimaruthur', ],
     Theni:['Theni','Aandipatti','Bodinayakanur','Periyakulam','Uthamapalayam'],
     Thiruvallur:['Thiruvallur','Avadi','Gummidipoondi','Pallipattu','Ponneri', 'Poonamallee', 'R.K. Pet','Tiruthani','Uthukottai'],
     Thiruvannamalai:['Thiruvannamalai',' Arni','Chengam','Chetpet','Cheyyar','Jamunamarathur','Kalasapakkam','Kilpennathur','Polur',' Thandramet','Vandavasi','Vembakkam'],
     Thiruvarur:['Thiruvarur','Kodavasal','Koothanallur','Mannargudi','Nannilam','Needamangalam','Thiruthuraipoondi','Valangaiman'],
     Thoothukudi:['Thoothukudi','Eral','Ettayapuram','Kayathar','Kovilpatti','Ottapidaram','Sattankulam','Srivaikundam','Tiruchendur','Vilathikulam',],
     Tiruchirappalli:['Lalgudi','Manachanallur', ' Manapparai',' Marungapuri','  Musiri',' Srirangam','  Thottiam', 'Thuraiyur',' Tiruchirapalli (West)','Tiruchirappalli (East)','Tiruverumbur'],
     Tirunelveli:['Tirunelveli','Ambasamudram','Cheranmahadevi','Manur','Nanguneri','Palayamkottai','Radhapuram','Thisayanvilai'],
     Vellore:['Vellore','Aanikattu','Gudiyatham','K V Kuppam','Katpadi','Pernambut', ],
     Villupuram:['Villupuram','Gingee','Kandachipuram','Marakanam','Melmalaiyanur','Thiruvennainallur','Tindivanam','Vanur','Vikravandi'],
     Virudhunagar:['Virudhunagar','Aruppukottai','Kariyapatti','Rajapalayam','Sathur','Sivakasi','Srivilliputhur','Tiruchuli','Vembakottai','Watrap' ],
     Ariyalur:[' Ariyalur','Andimadam','Sendurai','Udaiyarpalayam' ],
     Krishnagiri:['Krishnagiri','Anjetty','Bargur','Hosur','Pochampalli','Sulagiri','Thenkanikottai','Uthangarai',],
     Tiruppur:['Avinashi','Dharapuram','Kangeyam','Madathukkulam','Oothukuli','Palladam','Tiruppur (North)','Tiruppur (South)','Udumalaipettai' ],
     Chengalpattu:['Chengalpattu','Cheyyur','Maduranthakam','Pallavaram','Tambaram','Thirukalukundram','Tiruporur','Vandalur',],
     Kallakurichi:['Kallakurichi','Chinnaselam','Kalvarayan Hills','Sankarapuram','Tirukoilur','Ulundurpet',],
     Ranipet:['Arakkonam','Arcot','Kalavai','Nemili','Sholingur','Walajah',],
     Tenkasi:[ 'Tenkasi','Alangulam','Kadayanallur','Sankarankovil','Shenkottai','Sivagiri','Thiruvengadam','Veerakeralampudur', ],
     Tirupathur:['Tirupathur','Ambur','Natrampalli','Vaniyambadi',],
     Mayiladuthurai:['Mayiladuthurai',' Kuthalam','Sirkali','Tharangambadi',], 
  };

  const handlePay = (studentName, UserId, referralId) => {
    navi('/applyexam', { state: { studentName, UserId, referralId } });
  };

  const handleWalletPay=(studentName,UserId,referralId)=>{
    navi('/walletexam', { state: { studentName ,UserId  ,referralId } });
  }
  
  return (
    <div>
      <div style={{ marginBottom: '50px' }}>
        <Link to="/" className="logo_image">
          <img src="assets/headimg.jpg" alt="Cleenhearts HTML" style={{ width: '100%' }} />
        </Link>
      </div>

      <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
        <div
          onClick={handleAdd}
          style={{ width: '100px', height: '70px', backgroundColor: 'blueviolet', color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', margin: '10px' }}
        >
          ADD +
        </div>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: '10px', padding: '5px', width: '300px' }}
        />
         <h2>Total Students : <strong style={{color:'red'}}>{formData.length}</strong></h2>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p style={{ color: 'red' }}>{error}</p>
        ) : (
          < div style={{margin:"20px"}}>
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Student Name</th>
                  <th>Phone Number</th>
                  <th>UserID</th>
                  <th>Standard</th>
                  <th>Aadhar Number</th>
                  <th>Password</th>
                  <th>View</th>
                  <th>Edit</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((item, index) => (
                    <tr key={item.id}>
                      <td>{indexOfFirstItem + index + 1}</td>
                      <td>{item.studentName}</td>
                      <td>{item.phoneNumber}</td>
                      <td>{item.UserId}</td>
                      {(() => {
                        const matched = appliedData.find(data => data.UserId === item.UserId);
                        return matched ? <td>{matched.standard}</td> : <td>-</td>;
                      })()}
                      <td>{item.aadharNumber}</td>
                      <td>{item.viewpass}</td>
                      <td><button onClick={() => handleView(item.id)}>View</button></td>
                      <td><button onClick={() => handleEdit(item.id)}>Edit</button></td>
                      <td>
                        {appliedData.some(data => data.UserId === item.UserId) ? (
                          <button className="button applied" disabled>APPLIED</button>
                        ) : (
                          <button className="button" onClick={() => handlePay(item.studentName, item.UserId, item.referralid)}>APPLY EXAM</button>
                        )}
                        {
  !appliedData.some(data => data.UserId === item.UserId) ? (
    <button
      type="button"
      className="button"
      style={{ marginTop: '10px' }}
      onClick={() =>
        handleWalletPay(item.studentName, item.UserId, item.referralid)
      }
    >
      APPLY BY WALLET
    </button>
  ) : appliedData.some(data => data.UserId === item.UserId) ? (
    // If already applied normally, show "APPLIED" again for wallet
    <button
      type="button"
      className="button applied"
      style={{ marginTop: '10px' }}
      disabled
    >
      APPLIED
    </button>
  ) : null}
            
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" style={{ textAlign: 'center' }}>No data available</td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Pagination Controls */}
            {/* <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
              <button  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
                Previous
              </button>
              <span>Page {currentPage} of {totalPages}</span>
              <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
                Next
              </button>
            </div> */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'center', marginTop: '20px' }}>
  <button
    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}
    style={{
      padding: '10px 16px',
      backgroundColor: currentPage === 1 ? '#ccc' : 'green',
      color: '#fff',
      border: 'none',
      borderRadius: '8px',
      cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
      transition: '0.3s',
    }}
  >
    Previous
  </button>

  <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#333' }}>
    Page {currentPage} of {totalPages}
  </span>

  <button
    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
    disabled={currentPage === totalPages}
    style={{
      padding: '10px 16px',
      backgroundColor: currentPage === totalPages ? '#ccc' : 'green',
      color: '#fff',
      border: 'none',
      borderRadius: '8px',
      cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
      transition: '0.3s',
    }}
  >
    Next
  </button>
</div>

          </div>
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <div
          style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          onClick={handleCloseModal}
        >
          <div
            style={{ backgroundColor: 'white', padding: '20px', borderRadius: '10px', width: '400px', minHeight: '200px', overflowY: 'auto', position: 'relative' }}
            onClick={(e) => e.stopPropagation()}
          >
            {isEditing ? (
              <>
                <h3>Edit Details</h3>
                <form onSubmit={handleEditSubmit}>
                  <input type="text" id="studentName" placeholder="Student Name" value={editData.studentName || ''} onChange={handleChange} style={{ padding: '8px', marginBottom: '10px', width: '100%' }} />
                  <input type="text" id="phoneNumber" placeholder="Phone Number" maxLength={10} value={editData.phoneNumber || ''} onChange={handleChange} style={{ padding: '8px', marginBottom: '10px', width: '100%' }} />
                  <select id="district" value={district} onChange={handleDistrictChange} style={{ padding: '8px', marginBottom: '10px', width: '100%' }}>
                    <option value="">Select a district</option>
                    {Object.keys(districtToTalukas).map((districtKey) => (
                      <option key={districtKey} value={districtKey}>{districtKey}</option>
                    ))}
                  </select>
                  <select id="taluka" value={taluka} onChange={handleTalukaChange} style={{ padding: '8px', marginBottom: '10px', width: '100%' }}>
                    <option value="">Select Taluka</option>
                    {districtToTalukas[district]?.map((talukaItem, index) => (
                      <option key={index} value={talukaItem}>{talukaItem}</option>
                    ))}
                  </select>
                  <button type="submit" style={{ padding: '10px 20px', backgroundColor: '#007BFF', color: '#fff', border: 'none', cursor: 'pointer', borderRadius: '10px' }}>
                    Submit
                  </button>
                  {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                  {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
                </form>
              </>
            ) : (
              <div>
                <h3>View Details</h3>
                <p><strong>Student Name:</strong> {selectedItem?.studentName}</p>
                <p><strong>Phone Number:</strong> {selectedItem?.phoneNumber}</p>
                <p><strong>District:</strong> {selectedItem?.District}</p>
                <p><strong>Taluka:</strong> {selectedItem?.taluka}</p>
                {(() => {
                  const matched = appliedData.find(data => data.UserId === selectedItem?.UserId);
                  return matched ? (
                    <>
                      <p><strong>Medium:</strong> {matched.medium}</p>
                      <p><strong>Standard:</strong> {matched.standard}</p>
                    </>
                  ) : null;
                })()}
                <button onClick={handleCloseModal} style={{ position: 'absolute', top: '10px', right: '10px', backgroundColor: 'red', color: 'white', border: 'none', padding: '5px 10px', cursor: 'pointer' }}>
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Studentadd;
